import "../../wea-browser/style/index.less";
import "../../base/wea-associative-search/style/index.less";
import "./index.less";
import "./group.less";



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/style/index.js